import styled from '@emotion/styled';
import { TimePicker } from 'antd';
import moment from 'moment';
import React from 'react';
import { WithTranslation, withTranslation } from 'react-i18next';
import { connect } from 'react-redux';

import { AppState } from 'src/config/appState';
import i18n from 'src/config/i18n';
import { DatePicker } from 'src/modules/auth/containers/styles';

import { changeSingleValueQuestionAnswer } from '../actions/surveysActions';
import { QuestionComponentBaseProps, SurveySelectQuestionAnswer } from '../models/surveys';
import { getProgramSurveySingleQuestionAnswer } from '../selectors/surveysSelectors';
import { QuestionHeader } from './QuestionHeader';

const StyledTimePicker = styled<any>(TimePicker)({
    width: '18.38rem',
    '.ant-time-picker-input': {
        height: '2.63rem',
    },
});

interface StateProps {
    answer: SurveySelectQuestionAnswer | undefined;
}

interface ActionsProps {
    changeSingleValueQuestionAnswer: typeof changeSingleValueQuestionAnswer;
}

interface Props extends QuestionComponentBaseProps, StateProps, ActionsProps, WithTranslation {
    inputType: string;
    options: string[];
}

export class DateTimeQuestionContainer extends React.PureComponent<Props> {
    private handleDateChange = (_e: React.SyntheticEvent, data: { value: string }) => {
        const { programId, surveyId, id } = this.props;

        this.props.changeSingleValueQuestionAnswer({
            programId,
            surveyId,
            question: id,
            value: data.value,
        });
    };

    private handleTimeChange = (time: moment.Moment) => {
        const { programId, surveyId, id } = this.props;

        const timeString = time.format('hh:mm A');

        this.props.changeSingleValueQuestionAnswer({
            programId,
            surveyId,
            question: id,
            value: timeString,
        });
    };

    public render(): JSX.Element {
        const { answer, question, inputType, placeholder, readableIndex, t } = this.props;

        const selectedTime =
            answer && answer.data.content && moment(answer.data.content, 'hh:mm A');

        return (
            <>
                {question && <QuestionHeader index={readableIndex} header={question} />}
                {inputType === 'date' ? (
                    <DatePicker
                        style={{
                            '& input': {
                                width: '18.38rem',
                                height: '2.63rem',
                            },
                        }}
                        startMode="year"
                        format={t('inputs.dateTime.dateFormat')}
                        placeholder={placeholder}
                        initialDate={moment()}
                        minDate={moment().subtract(10, 'years')}
                        maxDate={moment().add(10, 'years')}
                        value={(answer && answer.data.content) || ''}
                        onChange={this.handleDateChange}
                        autoComplete="off"
                        clearable
                        closable
                    />
                ) : (
                    <StyledTimePicker
                        allowEmpty={false}
                        use12Hours={i18n.language === 'en'}
                        format={t('inputs.dateTime.timeFormat')}
                        onChange={this.handleTimeChange}
                        value={selectedTime}
                        placeholder={placeholder}
                    />
                )}
            </>
        );
    }
}

const mapStateToProps = (state: AppState, { programId, surveyId, id }: Props): StateProps => ({
    answer: getProgramSurveySingleQuestionAnswer(state, programId, surveyId, id) as
        | SurveySelectQuestionAnswer
        | undefined,
});

export const DateTimeQuestion = withTranslation()(
    connect(mapStateToProps, {
        changeSingleValueQuestionAnswer,
    })(DateTimeQuestionContainer),
);
